// extracted by mini-css-extract-plugin
export default {"ul":"scrollbar_ul__-xA4p","li":"scrollbar_li__xGx0c","li_active":"scrollbar_li_active__qON8v","button":"scrollbar_button__0yESJ"};